import { Component, OnInit, AfterContentInit, Input } from '@angular/core';
import { SvcServices } from 'app/services/svc.service';
import { PopupModalService } from "app/services/popup-modal.service";
import { GuidService } from 'app/services/guid.service';
import { SiteCatalystService } from 'app/services/site-catalyst.service';
import { ContentService } from 'app/services/content.service';

@Component({
  selector: 'popup-site-speedbump',
  templateUrl: './popup-site-speedbump.component.html'
})
export class PopupSiteSpeedbumpComponent implements OnInit, AfterContentInit {

  /**
   * This is only called in the footer and will always open a new window
   * This is not used by dmar
   */
  /* 
   * MOVE OUT: HOW params are passed in from directive
    @Input() params:any;
  */
  branding: any;
  modalData: any;
  isOpen: boolean = false;
  fullHref: any;
  _params: any;
  @Input('params') set params(value) {
    this._params = value;
  }

  // aria ids - required for anything that needs to be announced on open by the screen reader
  // note: not required for focusable elements, they are only announced when focused on
  ariaTitleId: string;
  ariaBodyId: string;
  ariaDescribedBy: string;

  constructor(
    private guidService: GuidService,
    private popupModalService: PopupModalService,
    private _svcServices: SvcServices,
    private _contentService: ContentService,
    private scService: SiteCatalystService) { }

  ngOnInit() {
    this._contentService.branding_content.subscribe((bData) => {
      bData = (bData.value) ? bData.value.content.CARDS : bData.content.CARDS;
      /*
      * Special Case:
      * Certain partners do not have an external site url property configured from CMS - ex: ELEC_APPL
      * For those cases, [SpeedbumpComponent] should not initialize since there is a CMS property dependency in [replaceDomain()]
      * Just in case it does - [data.content.CARDS.cmlink$$link_go_to_partner_site] condition is added 
      */
      if (bData !== null && bData !== undefined && bData.cmlink$$link_go_to_partner_site) {

        // load static CMS data
        this.branding = bData;
        if (this.branding && this.branding.cmlink$$link_go_to_partner_site) {
          this.fullHref = this.branding.cmlink$$link_go_to_partner_site.URL.FULL_URL;
        } else {
          this.fullHref = ""; // branding data missing
        }
        this.getPageData();
      }
    });
  }

  getPageData() {
    this._svcServices.invokeModalContentCall("jCARDS_svc_cw_modals").subscribe(data => {
      if (data !== null && data !== undefined && !!data.content) {
        this.modalData = (data.value) ? data.value.content.CARDS : data.content.CARDS;

        // with both branding and page data loaded, replace page data with branding
        this.modalData.headerTxt = this.replaceDomain('header_you_are_leaving_citibank');
        this.modalData.bodyTxt = this.replaceDomain('info_that_site_may_have_a_privacy');
        }
    });
  }
  
  ngAfterContentInit() {
    /* all aria required ids must be unique to keep screen reader from finding another instance of this component */
    this.ariaTitleId = this.guidService.getSimpleGuid();
    this.ariaBodyId = this.guidService.getSimpleGuid();

    // space separated string of all aria ids that are announced on open
    this.ariaDescribedBy = this.ariaTitleId + ' ' + this.ariaBodyId;
  }

  continue() {
    var target;
    target = '_blank';
    window.open(this.fullHref, target);
    this.popupModalService.closePopupContent.emit(null);
    this.scService.setSCPageData("speedbumpContinue", null, this.fullHref);
  }

  cancel() {
    this.popupModalService.closePopupContent.emit()
    this.scService.setSCPageData("speedbumpCancel", null);
  }

  replaceDomain(id: string) {
    if (this.branding && this.branding.cmlink$$link_go_to_partner_site) {
      let domainName = this.branding.cmlink$$link_go_to_partner_site.LINK_TEXT || '';
      return eval(`this.modalData.copy$$${id}.TEXT`).replace(/{{:domainName}}/g, domainName);
    } else {
      return id;  // branding data is missing
    }
  }

}



